import { db } from '@/lib/firebase';
import { doc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';

/**
 * Update the user profile document in Firestore.
 *
 * This is intentionally a small helper used by UI components (e.g. muting trip notifications)
 * to persist profile preferences.
 */
export async function updateUserProfile(
  uid: string,
  updates: Record<string, unknown>,
): Promise<void> {
  if (!uid) {
    throw new Error('updateUserProfile: uid is required');
  }

  const ref = doc(db, 'users', uid);
  await setDoc(
    ref,
    {
      ...updates,
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
}

/** Persists Safety screen "trip-only news" without replacing other `preferences` fields. */
export async function updateSafetyStrictDestinationNews(
  uid: string,
  strictDestinationNews: boolean,
): Promise<void> {
  if (!uid) {
    throw new Error('updateSafetyStrictDestinationNews: uid is required');
  }
  const ref = doc(db, 'users', uid);
  await updateDoc(ref, {
    'preferences.safety.strictDestinationNews': strictDestinationNews,
    updatedAt: serverTimestamp(),
  });
}

